/*
 * @Author: HANG ZHANG
 * @Date: 2020-06-04 20:06:28
 * @Description:
 * @LastEditors: HANG ZHANG
 * @LastEditTime: 2020-06-04 20:51:12
 * @FilePath: /vision-h5/src/modules/modal/index.js
 */

// 引入组件
import ModalWrapperComponent from './ModalWrapper.vue';
const ModalWrapper = {
	// install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
	install: function (Vue) {
		Vue.component('ModalWrapper', ModalWrapperComponent);
	},
};
// 导出
export default ModalWrapper;



// WEBPACK FOOTER //
// ./src/modules/modal/index.js